import React from 'react'
import Layout from '../Layouts/Layout'
import { Helmet } from 'react-helmet-async'

export default function About(){

    return (
        <Layout>
          <Helmet>
            <title>Haqqımızda | Kodart Tətbiq və Təlim Mərkəzi</title>
            <meta name="description" content="Kodart Tətbiq və Təlim Mərkəzi haqqında məlumat. Missiyamız, dəyərlərimiz və komandamız." />
            <link rel="canonical" href="https://kodart.az/haqqımızda" />
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="az_AZ" />
            <meta property="og:url" content="https://kodart.az/haqqımızda" />
            <meta property="og:title" content="Haqqımızda | Kodart" />
            <meta property="og:description" content="Kodart Tətbiq və Təlim Mərkəzi haqqında məlumat." />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content="Haqqımızda | Kodart" />
            <meta name="twitter:description" content="Kodart Tətbiq və Təlim Mərkəzi haqqında məlumat." />
          </Helmet>
          <p>About</p>
        </Layout>
    )
}